module.exports = __webpack_public_path__ + "img/banner_AIPlaza.9f17c1ac.png";